// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import './style.css';

function TableHeader (props) {
    const [tableHeaderSample] = useState({});
    // const [admin_type,setAdminType]= useState(null)
    // useEffect(() => {
    //     if (user_Status === 1) {
    //         setAdminType(UserData.login_Auth_Res.access_level);
    //         // adminData = this.state.adminType === 'location_admin' ? "Location Name" : null;
    //     }
    //   });
    // This method is for rendering Column header names
    function renderTableHeader() {
        let header = props.tableHeader ? Object.keys(props.tableHeader) : Object.keys(tableHeaderSample);
        return header.map((key, index) => {
            if(props.headerStatus===false){
                if(key === "location_admin")
                {
                    key=props.admin_type && "Location Name" ;
                }
                else if(key === "channel_admin"){
                    key=props.admin_type && "Channel Name";
                }
                else if(key === "admin"){
                    key=props.admin_type && "Location / Channel Name";
                }
            }
            if (index >= header.length - 1) {
                return (
                    <th style={{ textAlign: "right" }} key={index}>{key.toUpperCase()}</th>
                );
            } else {
                return (
                    <th key={index}>{key.toUpperCase()}</th>
                );
            }
        });
    }

    return (
        <React.Fragment>
            <tr className="">
                <th className="table-caption" colSpan="8">
                    <div className="draftsData">
                        <h4>{props.headerType}&nbsp;<span>({props.listLength})</span></h4>
                    </div>
                </th>
            </tr>
            <tr className="thead">{renderTableHeader()}</tr>
        </React.Fragment>
    )
}
export default TableHeader;




